import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend, Chart, Filler,
} from 'chart.js';
import {COLORS, FONTS} from "../utils/ChartFormatUtils";

export function registerComponents() {
    ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)
}

export function setupDefaults() {
    const def = Chart.defaults
    def.borderColor = COLORS.chartColorLight
    def.font = FONTS.text
}